import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {
  
  URL,
  GetMonthFirstDate,
  GetMonthLastDate,
  GetMonthFirstDate2,
  GetMonthLastDate2,
  SupplierList,
  CostTypeList,
  MembershipList,
  CustomerList,
  localFilePath,
} from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
import CgnButton from "../toolbox/CgnButton";
import CgnDatePicker from "../toolbox/CgnDatePicker";
import CgnReactSelect from "../toolbox/CgnReactSelect";

class CostList extends Component {
  state = {
    pageTitle: "Gider Listele",
    pageAddLink: "gider-ekle",
    pageUpdateLink: "gider-guncelle",
    pageDetailLink: "gider-detay",
    pageListLink: "gider-listele",
    pagePaymentAddLink: "odeme-ekle",
    pagePaymentListLink: "odeme-listele",
    breadcrumb: [{ text: "Gider", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    costData: [],
    discountTotal: 0,
    paymentTotal: 0,
    discountTotalDolar: 0,
    paymentTotalDolar: 0,
    discountTotalEuro: 0,
    paymentTotalEuro: 0,
    guid: "",
    alertErrorMessage: "",
    detail: false,
    firstDate: "",
    firstDate2: "",
    lastDate: "",
    lastDate2: "",
    supplierGuid: "00000000-0000-0000-0000-000000000000",
    supplierArr: [],
    membershipGuid: "00000000-0000-0000-0000-000000000000",
    membershipArr: [],
    costTypeGuid: "00000000-0000-0000-0000-000000000000",
    costTypeArr: [],
    customerGuid: "00000000-0000-0000-0000-000000000000",
    customerArr: [],
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });

    // 

    var firstDate = GetMonthFirstDate();
    var lastDate = GetMonthLastDate();
    var firstDate2 = GetMonthFirstDate2();
    var lastDate2 = GetMonthLastDate2();

    if (localStorage.getItem("firstDateCost")) {
      firstDate = localStorage.getItem("firstDateCost");
      firstDate2 = new Date(firstDate);
    }
    if (localStorage.getItem("lastDateCost")) {
      lastDate = localStorage.getItem("lastDateCost");
      lastDate2 = new Date(lastDate);
    }

    await this.setState({
      firstDate: firstDate,
      lastDate: lastDate,
      firstDate2: firstDate2,
      lastDate2: lastDate2,
    });

    var self = this;

    await SupplierList().then(function (data) {
      self.setState({
        supplierArr: data,
      });
    });

    if (localStorage.getItem("supplierGuidCost")) {
      this.setState({
        supplierGuid: localStorage.getItem("supplierGuidCost"),
      });
    }

    await MembershipList().then(function (data) {
      self.setState({
        membershipArr: data,
      });
    });

    if (localStorage.getItem("membershipGuidCost")) {
      this.setState({
        membershipGuid: localStorage.getItem("membershipGuidCost"),
      });
    }

    await CostTypeList().then(function (data) {
      self.setState({
        costTypeArr: data,
      });
    });

    if (localStorage.getItem("costTypeGuidCost")) {
      this.setState({
        costTypeGuid: localStorage.getItem("costTypeGuidCost"),
      });
    }

    await CustomerList().then(function (data) {
      self.setState({
        customerArr: data,
      });
    });

    if (localStorage.getItem("customerGuidCost")) {
      this.setState({
        customerGuid: localStorage.getItem("customerGuidCost"),
      });
    }

    this.getList();
  }

  async handleFirstDateChange(firstDate) {
    if (firstDate) {
      await this.setState({
        firstDate:
          firstDate.getMonth() +
          1 +
          "." +
          firstDate.getDate() +
          "." +
          firstDate.getFullYear(),
        firstDate2: firstDate,
      });
    } else {
      var firstDate = GetMonthFirstDate();
      await this.setState({
        firstDate: firstDate,
        firstDate2: firstDate,
      });
    }
    localStorage.setItem("firstDateCost", this.state.firstDate);
  }

  async handleLastDateChange(lastDate) {
    if (lastDate) {
      await this.setState({
        lastDate:
          lastDate.getMonth() +
          1 +
          "." +
          lastDate.getDate() +
          "." +
          lastDate.getFullYear(),
        lastDate2: lastDate,
      });
    } else {
      var lastDate = GetMonthLastDate();
      await this.setState({
        lastDate: lastDate,
        lastDate2: lastDate,
      });
    }
    localStorage.setItem("lastDateCost", this.state.lastDate);
  }

  async handleSupplierSelectChange(option) {
    if (option) {
      await this.setState({
        supplierGuid: option.value,
      });
    } else {
      await this.setState({
        supplierGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("supplierGuidCost", this.state.supplierGuid);
  }

  async handleCustomerSelectChange(option) {
    if (option) {
      await this.setState({
        customerGuid: option.value,
      });
    } else {
      await this.setState({
        customerGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("customerGuidCost", this.state.customerGuid);
  }

  async handleMembershipSelectChange(option) {
    if (option) {
      await this.setState({
        membershipGuid: option.value,
      });
    } else {
      await this.setState({
        membershipGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("membershipGuidCost", this.state.membershipGuid);
  }

  async handleCostTypeSelectChange(option) {
    if (option) {
      await this.setState({
        costTypeGuid: option.value,
      });
    } else {
      await this.setState({
        costTypeGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("costTypeGuidCost", this.state.costTypeGuid);
  }

  getList = async () => {
    this.setState({
      isLoading: true,
    });

    // 

    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    let urlSplit = window.location.pathname.split("/");
    var URLParam = "";
    if (urlSplit[1] === "musteri-detay") {
      URLParam = "/costs/getlistforcustomer/" + urlSplit[2];
      this.setState({
        detail: true,
      });
    } else if (urlSplit[1] === "tedarikci-detay") {
      URLParam = "/costs/getlistforsupplier/" + urlSplit[2];
      this.setState({
        detail: true,
      });
    } else {
      URLParam =
        "/costs/getlist" +
        "/" +
        this.state.firstDate +
        "/" +
        this.state.lastDate +
        "/" +
        this.state.supplierGuid +
        "/" +
        this.state.membershipGuid +
        "/" +
        this.state.costTypeGuid +
        "/" +
        this.state.customerGuid;
    }
    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        this.setState({
          costData: response.data,
          isLoading: false,
        });
        var discountTotal = 0;
        var paymentTotal = 0;
        var discountTotalDolar = 0;
        var paymentTotalDolar = 0;
        var discountTotalEuro = 0;
        var paymentTotalEuro = 0;
        response.data.forEach((element) => {
          if (element.currencyType === 1) {
            discountTotal += element.discountTotal;
            paymentTotal += element.paymentTotal;
          } else if (element.currencyType === 2) {
            discountTotalDolar += element.discountTotal;
            paymentTotalDolar += element.paymentTotal;
          } else if (element.currencyType === 3) {
            discountTotalEuro += element.discountTotal;
            paymentTotalEuro += element.paymentTotal;
          }
        });
        this.setState({
          discountTotal: discountTotal,
          paymentTotal: paymentTotal,
          discountTotalDolar: discountTotalDolar,
          paymentTotalDolar: paymentTotalDolar,
          discountTotalEuro: discountTotalEuro,
          paymentTotalEuro: paymentTotalEuro,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handlePdfPrint = async (guid) => {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/costs/print/" + guid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/costs/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  thStyle = {
    width: "125px",
  };

  thStyle2 = {
    width: "95px",
  };

  tdStyle = {
    width: "150px",
  };

  render() {
    const remainingTotal = this.state.discountTotal - this.state.paymentTotal;
    const remainingTotalDolar =
      this.state.discountTotalDolar - this.state.paymentTotalDolar;
    const remainingTotalEuro =
      this.state.discountTotalEuro - this.state.paymentTotalEuro;

    return (
      <>
        {this.state.detail === false && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        
        <Row className="costList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              {this.state.detail === false && (
                <Row className="filterRow">
                  <Col className="pl-2 pr-2" md="1">
                    <CgnDatePicker
                      name="firstDate"
                      label="Baş. Tarihi"
                      selected={
                        this.state.firstDate2 &&
                        this.state.firstDate2.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.firstDate2.split("/")[2] +
                                "-" +
                                this.state.firstDate2.split("/")[1] +
                                "-" +
                                this.state.firstDate2.split("/")[0]
                            )
                          : this.state.firstDate2
                      }
                      onChange={(firstDate2) =>
                        this.handleFirstDateChange(firstDate2)
                      }
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="1">
                    <CgnDatePicker
                      name="lastDate"
                      label="Bit. Tarihi"
                      selected={
                        this.state.lastDate2 &&
                        this.state.lastDate2.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.lastDate2.split("/")[2] +
                                "-" +
                                this.state.lastDate2.split("/")[1] +
                                "-" +
                                this.state.lastDate2.split("/")[0]
                            )
                          : this.state.lastDate2
                      }
                      onChange={(lastDate2) =>
                        this.handleLastDateChange(lastDate2)
                      }
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="2">
                    <CgnReactSelect
                      name="supplierGuid"
                      label="Tedarikçi"
                      placeholder="Tedarikçi seçiniz..."
                      selectValue={this.state.supplierGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleSupplierSelectChange(option)
                      }
                      options={this.state.supplierArr}
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="3">
                    <CgnReactSelect
                      name="customerGuid"
                      label="Müşteri"
                      placeholder="Müşteri seçiniz..."
                      selectValue={this.state.customerGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleCustomerSelectChange(option)
                      }
                      options={this.state.customerArr}
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="2">
                    <CgnReactSelect
                      name="membershipGuid"
                      label="Personel"
                      placeholder="Personel seçiniz..."
                      selectValue={this.state.membershipGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleMembershipSelectChange(option)
                      }
                      options={this.state.membershipArr}
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="2">
                    <CgnReactSelect
                      name="costTypeGuid"
                      label="Gider Türü"
                      placeholder="Gider türü seçiniz..."
                      selectValue={this.state.costTypeGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleCostTypeSelectChange(option)
                      }
                      options={this.state.costTypeArr}
                    />
                  </Col>
                  <Col className="pl-2 pr-0" md="1">
                    <CgnButton
                      type="button"
                      color="primary"
                      onClick={this.getList}
                      text="Listele"
                      className="listButton"
                    />
                  </Col>
                </Row>
              )}
              <CgnDatatable
                data={this.state.costData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Gider Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Tarih</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>{row.costDate}</td>
                              <th style={this.thStyle2}>Gider Türü</th>
                              {/* <th className="colon">:</th> */}
                              <td>
                                {row.costTypeName ? row.costTypeName : "-"}
                              </td>
                            </tr>
                            {row.employeeName !== " " && (
                              <tr>
                                <th style={this.thStyle}>Personel</th>
                                {/* <th className="colon">:</th> */}
                                <td colSpan={4}>
                                  {row.employeeName === " "
                                    ? "-"
                                    : row.employeeName}
                                </td>
                              </tr>
                            )}
                            {row.supplierName && (
                              <tr>
                                <th style={this.thStyle}>Tedarikçi</th>
                                {/* <th className="colon">:</th> */}
                                <td colSpan={4}>
                                  {row.supplierName ? row.supplierName : "-"}
                                </td>
                              </tr>
                            )}
                            {row.customerName && (
                              <tr>
                                <th style={this.thStyle}>Müşteri</th>
                                {/* <th className="colon">:</th> */}
                                <td colSpan={4}>
                                  {row.customerName ? row.customerName : "-"}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <th style={this.thStyle}>Toplam Tutar</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>
                                {row.discountTotal.toLocaleString("tr-TR", {
                                  minimumFractionDigits: 2,
                                }) +
                                  " " +
                                  (row.currencyType === 1
                                    ? "₺"
                                    : row.currencyType === 2
                                    ? "$"
                                    : row.currencyType === 3
                                    ? "€"
                                    : "-")}
                              </td>
                              <th style={this.thStyle2}>Ödenen Tutar</th>
                              {/* <th className="colon">:</th> */}
                              <td>
                                {row.paymentTotal.toLocaleString("tr-TR", {
                                  minimumFractionDigits: 2,
                                }) +
                                  " " +
                                  (row.currencyType === 1
                                    ? "₺"
                                    : row.currencyType === 2
                                    ? "$"
                                    : row.currencyType === 3
                                    ? "€"
                                    : "-")}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Kalan Tutar</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={4}>
                                {(
                                  row.discountTotal - row.paymentTotal
                                ).toLocaleString("tr-TR", {
                                  minimumFractionDigits: 2,
                                }) +
                                  " " +
                                  (row.currencyType === 1
                                    ? "₺"
                                    : row.currencyType === 2
                                    ? "$"
                                    : row.currencyType === 3
                                    ? "€"
                                    : "-")}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ekleyen Kullanıcı</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={4}>{row.createdBy}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: "Yazdır",
                            className: "dropDownBtn",
                            onClick: () => this.handlePdfPrint(row.guid),
                          },
                          // { text: "Ödeme Ekle", className:"dropDownBtn", href:`/${this.state.pagePaymentAddLink}/${row.guid}`},
                          // { text: "Ödeme Listele", className:"dropDownBtn", href:`/${this.state.pagePaymentListLink}/${row.guid}`},
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
            <div className="d-block clearfix">
              <div className="float-right ListDownButton">
                Toplam Kalan Tutar (₺):{" "}
                {remainingTotal.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                ₺
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Ödenen Tutar (₺):{" "}
                {this.state.paymentTotal.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                ₺
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Tutar (₺):{" "}
                {this.state.discountTotal.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                ₺
              </div>
            </div>
            <div className="d-block clearfix">
              <div className="float-right ListDownButton">
                Toplam Kalan Tutar ($):{" "}
                {remainingTotalDolar.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                $
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Ödenen Tutar ($):{" "}
                {this.state.paymentTotalDolar.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                $
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Tutar ($):{" "}
                {this.state.discountTotalDolar.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                $
              </div>
            </div>
            <div className="d-block clearfix">
              <div className="float-right ListDownButton">
                Toplam Kalan Tutar (€):{" "}
                {remainingTotalEuro.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                €
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Ödenen Tutar (€):{" "}
                {this.state.paymentTotalEuro.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                €
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Tutar (€):{" "}
                {this.state.discountTotalEuro.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                €
              </div>
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

export default CostList;
